var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: "修改标记",
        visible: _vm.dialogVisible,
        width: "400px",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.form.isHold,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "isHold", $$v)
                },
                expression: "form.isHold",
              },
            },
            [_vm._v("查验品名")]
          ),
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.form.isBlacklist,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "isBlacklist", $$v)
                },
                expression: "form.isBlacklist",
              },
            },
            [_vm._v("黑名单")]
          ),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c(
            "div",
            {
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v("确 定")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }